module.exports = __webpack_public_path__ + "img/pai.443b3a84.png";